/**
 * First failing check wins: silence → no speech → noise.
 * Treats non-true as fail (used after confirming an explicit false exists).
 */
export function buildFailReason(flags) {
  if (flags.has_audio !== true) return "silence";
  if (flags.has_speech !== true) return "no_speech";
  if (flags.is_speech_clear !== true) return "noise";
  return null;
}

/**
 * Fail reason from persisted assessment audio_quality flags.
 * Ignores all-null (not evaluated). Warns only when at least one flag is false.
 */
export function failReasonFromStoredAudioQuality(flags) {
  if (!flags) return null;

  const anyExplicitFail =
    flags.has_audio === false ||
    flags.has_speech === false ||
    flags.is_speech_clear === false;

  if (!anyExplicitFail) return null;

  return buildFailReason(flags);
}

export function getAudioQualityFlagsFromAssessment(assessment) {
  if (!assessment) return null;
  return assessment.audio_quality ?? assessment.result?.audio_quality ?? null;
}
